export const ru = {
    confirm: 'Пожалуйста, подтвердите действие',
    error: 'Ошибка',
};
